<template>
<div class="bus-wrapper">
  <div class="bus-detail" :style="iphoneX ? `height: calc(100vh - ${offset}px - 195px - 34px)` : `height: calc(100vh - ${offset}px - 195px)`" ref="wrapper">
    <cube-scroll ref="scroll"
                 :scroll-events="['scroll']"
                 @scroll="handleScroll"
                 :data="route.routeArray"
                 class="horizontal-scroll-list-wrap">
      <div class="detail">
        <div class="detail-container">
          <!-- 占位 -->
          <div class="icon"></div>
          <div class="start-box">
            <div class="separator">
              <img src="../../assets/my-location.svg" />
            </div>
            <div class="info">{{ $t('navigate.start') }} ({{ startName || $t('common.myLocation') }})</div>
          </div>
        </div>
      </div>
      <div class="detail"
          v-for="(item, index) in route.routeArray"
          :key="`${item.type}-${index}`">
        <div class="detail-container" v-if="item.type === 0">
          <div class="icon">
            <img src="../../assets/navigate/walk-gray.svg" />
          </div>
          <div class="separator walk">
            <div class="line">
              <div class="dot" v-for="n in 6" :key="n"></div>
            </div>
          </div>
          <div class="walk-info-box">
            <div class="walk-info">{{ $t('navigate.walk') }}</div>
            <div class="walk-img">
              <img src="../../assets/navigate/walk-icon.svg" @click.stop="zoomToWalk(item)"/>
            </div>
          </div>
        </div>
        <div class="bus-wrapper" v-else-if="item.type !== 7">
          <div class="detail-container">
            <div class="icon" v-if="siteId === '1'">
              <img src="../../assets/navigate/bus-gray-sentosa.svg" v-if="item.type === 1 || item.type === 2 || item.type === 3" />
              <img src="../../assets/navigate/express-gray.svg" v-else-if="item.type === 4" />
              <img src="../../assets/navigate/tram-gray.svg" v-else-if="item.type === 5" />
              <img src="../../assets/navigate/cable-gray-sentosa.svg" v-else-if="item.type === 6" />
            </div>
            <div class="icon" v-else>
              <img src="../../assets/navigate/bus-gray.svg" v-if="item.type === 1 || item.type === 2 || item.type === 3" />
              <img src="../../assets/navigate/express-gray.svg" v-else-if="item.type === 4" />
              <img src="../../assets/navigate/tram-gray.svg" v-else-if="item.type === 5" />
              <img src="../../assets/navigate/cable-gray.svg" v-else-if="item.type === 6" />
            </div>
            <div class="separator bus" v-if="item.type === 1 || item.type === 2 || item.type === 3">
              <div class="line"></div>
            </div>
            <div class="separator bus express" v-if="item.type === 4">
              <div class="line"></div>
            </div>
            <div class="separator bus tram" v-if="item.type === 5">
              <div class="line"></div>
            </div>
            <div class="separator bus cable" v-if="item.type === 6">
              <div class="line"></div>
            </div>
            <div class="bus-info">
              <div class="stop-name">{{ route.meta.transportations[item.tIndex].start_stop_name }}</div>
              <div class="bus-label" v-if="item.type === 1">{{ $t('navigate.bus') }}A</div>
              <div class="bus-label" v-else-if="item.type === 2">{{ $t('navigate.bus') }}B</div>
              <div class="bus-label" v-else-if="item.type === 3">{{ $t('navigate.bus') }}123</div>
              <div class="bus-label express" v-else-if="item.type === 4">{{ $t('navigate.express') }}</div>
              <div class="bus-label tram" v-else-if="item.type === 5">{{ $t('navigate.tram') }}</div>
              <div class="bus-label cable" v-else-if="item.type === 6">{{ $t('navigate.cable') }}</div>
              <div class="bus-info" v-if="route.meta.transportations[item.tIndex].vehicle === 'bus' && route.meta.transportations[item.tIndex].next_arriving_time !== -1 && route.meta.transportations[item.tIndex].next_arriving_time !== null">{{ route.meta.transportations[item.tIndex].next_arriving_time > 0 ? $t("navigate.ariiveAfterMinutes", { mins: route.meta.transportations[item.tIndex].next_arriving_time }) : $t('navigate.arriveSoon') }}</div>
              <div class="bus-stops">{{ route.meta.transportations[item.tIndex].number_of_stops }}{{ $t('navigate.stops') }}</div>
              <div class="stop-name">{{ route.meta.transportations[item.tIndex].end_stop_name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="detail-container">
          <!-- 占位 -->
          <div class="icon"></div>
          <div class="end-box">
            <div class="separator">
              <img src="../../assets/my-location.svg" />
            </div>
            <div class="info">{{ endName }}</div>
          </div>
        </div>
      </div>
      <div class="empty-node" v-if="safari" style="height: 50px"></div>
    </cube-scroll>
  </div>
</div>
</template>

<script>
  import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

  export default {
  data () {
    return {
      routeDetail: {},
      scrollTop: 0
    }
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    },
    safari () {
      return this.$store.state.safari
    }
  },
  props: {
    route: {
      type: Object,
      default: () => {
        return {}
      }
    },
    startName: {
      type: String,
      default: ''
    },
    endName: {
      type: String,
      default: ''
    },
    offset: {
      type: Number,
      default: 0
    },
    iphoneX: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleScroll (e) {
      this.scrollTop = e.y
      console.log(e.y)
    },
    zoomToWalk(item) {
      var coordinates = item.array.map(item=> {
        return [item[0], item[1]]
      })
      const map = this.$parent.$parent.$refs.cmap.map
      var bounds = coordinates.reduce(function(bounds, coord) {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
      map.fitBounds(bounds, {
        padding: 20
      });
      this.$parent.handleClose()
    }
  },
  mounted() {
    console.log(this.route.routeArray)
  }
}
</script>

<style lang="scss" scoped>
.bus-detail {
  padding-left: 31px;
  // height: calc(100vh - 187px);
  overflow: auto;
  padding-bottom: 20px;
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  .start-box,
  .end-box {
    display: flex;
    align-items: center;

    .info {
      font-size: 16px;
      max-width: 260px;
      color: #222125;
    }
  }

  .start-box {
    padding-top: 8px;
  }

  .icon {
    width: 20px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -11px;
    img {
      display: block;
    }
  }

  .detail-container {
    display: flex;
    // align-items: center;
    position: relative;
  }

  .separator {
    width: 24px;
    margin-right: 12px;
    margin-left: 33px;
    flex-shrink: 0;

    img {
      display: block;
    }
  }

  .walk-info-box {
    display: flex;
    align-items: center;
    width: 76%;
    justify-content: space-between;
    .walk-info {
      font-size: 14px;
      color: #888888;
      padding: 18px 0 21px;
    }
  }

  .separator {
    display: flex;
    justify-content: center;

    &.walk .line {
      height: 100%;
      width: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;

      .dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #efefef;
      }
    }

    &.bus {
      padding: 5px 0;
      .line {
        width: 8px;
        height: 100%;
        border-radius: 8px;
        background-color: #ffa700;
        position: relative;

        &:before,
        &:after {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #ffffff;
          position: absolute;
          left: 2.1px;
        }

        &:before {
          top: 2px;
        }

        &:after {
          bottom: 2px;
        }
      }

      &.cable {
        .line {
          background-color: #5c2d91;
        }
      }

      &.express {
        .line {
          background-color: #28752b;
        }
      }

      &.tram {
        .line {
          background-color: #f15b67;
        }
      }
    }
  }

  .bus-info {
    .stop-name {
      font-size: 16px;
      color: #222125;
    }

    .bus-label {
      padding: 0 9px;
      height: 20px;
      border-radius: 4px;
      background-color: #ffa700;
      font-size: 12px;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      display: inline-block;
      margin: 5px 0;

      &.cable {
        background-color: #5c2d91;
      }

      &.tram {
        background-color: #f15b67;
      }

      &.express {
        background-color: #28752b;
      }
    }

    .bus-info {
      font-size: 12px;
      color: #55b6b3;
    }

    .bus-stops {
      font-size: 12px;
      color: #222125;
      line-height: 17px;
      margin: 25px 0;
    }
  }
}
</style>
